module.exports = __webpack_public_path__ + "static/media/search_prototype_results_blur.066a69cc.png";